import styled from 'styled-components';

const HorizontalTabHighlight = styled.hr`
  display: flex;
  height: 2px;

  margin: 0;

  background: var(--content-body);
  border-radius: 0;
  border: 0;

  position: absolute;
  left: 0;
  bottom: 0;

  transition: ${({ disableTransition }) =>
    disableTransition ? 'none' : 'left 150ms ease-out, width 150ms ease-out'};
`;

export { HorizontalTabHighlight };
